import React, { Component } from 'react'
import Included from '../Included'
import DarkThemeNav from '../common/dark-theme-nav';
class Tabs extends Component {

  constructor(props) {
    super(props)
  }


  render (){
    return(
    <section><a className="anchor"id="tabs"></a>
    <h2>Tabs</h2>
    <p>Tabbed components are useful when grouping like data or content into groups. Tabbed components take their lead from content containers but have a set of tabs that run the full width of the container.</p>
    <DarkThemeNav anchor="tabs" />

    <h3>Default styling</h3>

    <div className="tabs js-tabs">
        <div className="tabs__toggle-group">
          <div className="tabs__toggle tabs__toggle--active">Jules Verne</div>
          <div className="tabs__toggle">Around the World</div>
          <div className="tabs__toggle">80 Days</div>
        </div>
        <div className="tabs__tabs-group">
          <div className="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
          <div className="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
          <div className="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
        </div>
    </div>
    <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="tabs js-tabs">
    <div class="tabs__toggle-group">
      <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>
      <div class="tabs__toggle">Around the World</div>
      <div class="tabs__toggle">80 Days</div>
    </div>
    <div class="tabs__tabs-group">
      <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
      <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
      <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
    </div>
</div>`}</code></pre>

    <br/>

    <h3>Lite styling</h3>

    <div className="tabs tabs--lite js-tabs-lite">
        <div className="tabs__toggle-group">
          <div className="tabs__toggle tabs__toggle--active">Jules Verne</div>
          <div className="tabs__toggle">Around the World</div>
          <div className="tabs__toggle">80 Days</div>
        </div>
        <div className="tabs__tabs-group">
          <div className="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
          <div className="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
          <div className="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
        </div>
    </div>
    <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="tabs tabs--lite js-tabs">
    <div class="tabs__toggle-group">
      <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>
      <div class="tabs__toggle">Around the World</div>
      <div class="tabs__toggle">80 Days</div>
    </div>
    <div class="tabs__tabs-group">
      <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
      <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
      <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
    </div>
</div>`}</code></pre>

    <br/>

    <h4>Full Width Styling</h4>

    <p>By default, each tab will only consume as much space as it needs. It is possible to specify that the tabs consume the full width of the containing element. To set the container to full width, just add the <code className="inline">tabs__toggle-group--full-width</code> modifier class to the containing element.</p>

    <div className="tabs js-tabs">
      <div className="tabs__toggle-group tabs__toggle-group--full-width">
        <div className="tabs__toggle tabs__toggle--active">Jules Verne</div>
        <div className="tabs__toggle">Around the World</div>
        <div className="tabs__toggle">80 Days</div>
      </div>
      <div className="tabs__tabs-group">
        <div className="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
        <div className="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
        <div className="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
      </div>
    </div>
    <br/>

      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="tabs js-tabs">
    <div class="tabs__toggle-group tabs__toggle-group--full-width">
      <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>
      <div class="tabs__toggle">Around the World</div>
      <div class="tabs__toggle">80 Days</div>
    </div>
    <div class="tabs__tabs-group">
      <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
      <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
      <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
    </div>
</div>`}</code></pre>

    <br/>

      <p>This is a javascript enabled component. You need to use the classes shown above, or pass in the variation to the library.</p>

    <pre><code className="language-javascript">{`// Using default classes shown in snippet.
// The library looks for the class 'js-tabs' by default.
commonUI.initializeTabs();

// You can have multiple tab group on the page, they will all be initialised

// Using a custom selector
commonUI.initializeTabs({selector:'.special-tabs'});

// Access to the tabs can be achieved programatically.
var tabs = commonUI.initializeTabs();
tabs.open({index: 0}); // Opens the first tab
tabs.open({index: 1}); // Opens the second tab
tabs.close({index: 0}); // Closes the first tab
tabs.close({index: 1}); // Closes the second tab

// Tabs can also be open and closed by a selector.
// <div class="tabs__tab" id="livestock-tab">Content</div>
tabs.open({selector: '#livestock-tab'}); // Opens the tab with the corresponding id `}</code></pre>

      <br/>
      <h3>Scrollable</h3>
      <p>Pass in the "scrollable" flag and the tabs will become horizontally scrollable</p>

      <div className="tabs js-scrollable-tabs">
        <div className="tabs__toggle-group">
          <div className="tabs__toggle tabs__toggle--active">Tab Option 1</div>
          <div className="tabs__toggle">Tab Option 2</div>
          <div className="tabs__toggle is-closeable">Tab Option 3 with really long text</div>
          <div className="tabs__toggle">Tab Option 4</div>
          <div className="tabs__toggle">Tab Option 5</div>
          <div className="tabs__toggle">Tab Option 6</div>
          <div className="tabs__toggle">Tab Option 7</div>
          <div className="tabs__toggle">Tab Option 8</div>
          <div className="tabs__toggle">Tab Option 9</div>
          <div className="tabs__toggle">Tab Option 10</div>
        </div>
        <div className="tabs__tabs-group">
          <div className="tabs__tab">Tab 1 Content</div>
          <div className="tabs__tab">Tab 2 Content</div>
          <div className="tabs__tab">Tab 3 Content</div>
          <div className="tabs__tab">Tab 4 Content</div>
          <div className="tabs__tab">Tab 5 Content</div>
          <div className="tabs__tab">Tab 6 Content</div>
          <div className="tabs__tab">Tab 7 Content</div>
          <div className="tabs__tab">Tab 8 Content</div>
          <div className="tabs__tab">Tab 9 Content</div>
          <div className="tabs__tab">Tab 10 Content</div>
        </div>
      </div>
      <br/>
      <pre><code className="language-javascript">{`commonUI.initializeTabs({scrollable: true});`}</code></pre>

      <br/>
      <h3>Programatically Add/Remove Tabs</h3>
      <p>Tabs expose methods which can be used to programatically add or remove tabs.</p>

      <pre><code className="language-javascript">{`let tabs = commonUI.initializeTabs({scrollable: true});

// Add a new tab
var newTab = tabs.add({
  title: 'A New Tab',
  closeable: true
});

// To set the content of the tab
newTab.tab.innerHTML = 'This tab will self destruct in 5 seconds &hellip;';

// Remove the tab created above
newTab.remove();

// or you can remove a tab by its index
tabs.remove({
  index: 1
});`}</code></pre>



      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="480">480px (xs)</option>
        <option value="768">768px (sm)</option>
        <option value="992">992px (md)</option>
        <option value="1200">1200px (lg)</option>
      </select>

      <br/><br/>
      <div className="iframe-container" style={{"height":"175px"}}>
        <iframe seamless srcDoc={`<html>
          <head>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
            <link rel="stylesheet" type="text/css" href="css/commonUI.css">
            <link rel="stylesheet" type="text/css" href="css/styleguide.css">
          </head>
          <body>
            <div class="tabs js-scrollable-tabs" id="scrollableTabsExample">
              <div class="tabs__toggle-group">
                <div class="tabs__toggle tabs__toggle--active">Tab Option 1</div>
                <div class="tabs__toggle">Tab Option 2</div>
                <div class="tabs__toggle is-closeable">Tab Option 3 with really long text</div>
              </div>
              <div class="tabs__tabs-group">
                <div class="tabs__tab">Tab 1 Content</div>
                <div class="tabs__tab">Tab 2 Content</div>
                <div class="tabs__tab">Tab 3 Content</div>
              </div>
            </div>
            <div class="soft-half">
              <button class="btn btn--small js-action--add-tab">Add Tab</button><button class="btn btn--small push-half--left js-action--remove-tab">Remove Tab</button>
            </div>
          </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    let tabs;
    function init() {
      tabs = commonUI.initializeTabs({selector: '#scrollableTabsExample', scrollable: true, responsive: true});
    }
    window.onload = init;
    var btnAddTab = document.querySelector('.js-action--add-tab');
    var btnRemoveTab = document.querySelector('.js-action--remove-tab');
    btnAddTab.addEventListener('click', function() {
      var tabTitle = prompt("Please specify the title of the new tab?");
      if (tabTitle) {
        var newTab = tabs.add({title: tabTitle, closeable: true});
        newTab.tab.innerHTML = 'Tab Content';
      }
    });
    btnRemoveTab.addEventListener('click', function() {
      var tabNumber = prompt("Please specify which tab number to remove?");
      if (tabNumber && !isNaN(tabNumber)) {
        tabs.remove({index: tabNumber - 1});
      }
    });
  </script>
</html>`}></iframe>
      </div>

      <br/>
      <h3>Responsive</h3>
      <p>Pass in the responsive flag and the tabs will collapse to a dropdown on small screens.</p>
      <select className="size-select">
        <option value="auto">Select a resolution</option>
        <option value="480">480px (xs)</option>
        <option value="768">768px (sm)</option>
        <option value="992">992px (md)</option>
        <option value="1200">1200px (lg)</option>
      </select>
      <br/><br/>
      <div className="iframe-container" style={{"height":"300px"}}>
        <iframe seamless srcDoc={`<html>
  <head>
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
    <link rel="stylesheet" type="text/css" href="css/commonUI.css">
    <link rel="stylesheet" type="text/css" href="css/styleguide.css">
  </head>
  <body>
    <div class="tabs js-responsive-tabs" id="responsiveTabsExample">
      <div class="tabs__toggle-group">
        <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>
        <div class="tabs__toggle">Around the World</div>
        <div class="tabs__toggle">80 Days</div>
      </div>
      <div class="tabs__tabs-group">
        <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
        <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
        <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
      </div>
    </div>
  </body>
  <script type="text/javascript" src="js/commonUI.js"></script>
  <script>
    function init() {
      commonUI.initializeTabs({selector: '#responsiveTabsExample', responsive: true});
    }
    window.onload = init;
  </script>
</html>`}></iframe>
      </div>
      <br/>
      <pre><code className="language-javascript">{`commonUI.initializeTabs({responsive: true});`}</code></pre>
  <br/>

    <h4>Vertical</h4>
    <p>Tabs will default to a horizontal layout. To change the orientation pass the vertical flag in the initialisation options. Vertical tabs also work responsively, just pass the responsive flag in the initialisation options.</p>

    <select className="size-select">
      <option value="auto">Select a resolution</option>
      <option value="480">480px (xs)</option>
      <option value="768">768px (sm)</option>
      <option value="992">992px (md)</option>
      <option value="1200">1200px (lg)</option>
    </select>
    <br/><br/>

    <div className="iframe-container" style={{"height":"300px"}}>
      <iframe seamless srcDoc={`<html>
        <head>
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
          <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
          <link rel="stylesheet" type="text/css" href="css/commonUI.css">
          <link rel="stylesheet" type="text/css" href="css/styleguide.css">
        </head>
        <body>
          <div class="tabs tabs--vertical" id="verticalTabsExample">
            <div class="tabs__toggle-group">
              <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>
              <div class="tabs__toggle">Around the World</div>
              <div class="tabs__toggle">80 Days</div>
            </div>
            <div class="tabs__tabs-group">
              <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
              <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
              <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
            </div>
          </div>
        </body>
        <script type="text/javascript" src="js/commonUI.js"></script>
        <script>
          function init() {
            commonUI.initializeTabs({selector: '#verticalTabsExample', vertical: true, responsive: true});
          }
          window.onload = init;
        </script>
        </html>`}>
      </iframe>
    </div>

    <pre><code className="language-javascript">{`commonUI.initializeTabs({vertical: true, responsive: true});`}</code></pre>

    <br/><hr/><br/>

    <h4>Light Vertical</h4>
    <p>With light styling. Tabs will default to a horizontal layout. To change the orientation pass the vertical flag in the initialisation options. Vertical tabs also work responsively, just pass the responsive flag in the initialisation options.</p>

    <select className="size-select">
      <option value="auto">Select a resolution</option>
      <option value="478">480px (xs)</option>
      <option value="768">768px (sm)</option>
      <option value="992">992px (md)</option>
      <option value="1200">1200px (lg)</option>
    </select>
    <br/><br/>

    <div className="iframe-container" style={{"height":"500px", "border": "0"}}>
      <iframe seamless srcDoc={`<html>
        <head>
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
          <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">
          <link rel="stylesheet" type="text/css" href="css/commonUI.css">
          <link rel="stylesheet" type="text/css" href="css/styleguide.css">
        </head>
        <body>
          <div class="tabs tabs--lite tabs--vertical" id="liteVerticalTabsExample">
            <div class="tabs__toggle-group visuallyhidden--xs-only soft-half--top soft-half--bottom">
              <h5 class="tabs__toggle--title push-half">Category Title</h5>
              <div class="tabs__toggle tabs__toggle--active">Level 2</div>
              <div class="tabs__toggle">Level 2</div>
              <div class="tabs__toggle">Level 2</div>
              <h5 class="tabs__toggle--title push-half--sides push--top push-half--bottom">Category Title</h5>
              <div class="tabs__toggle">Level 2</div>
              <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>
              <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>
              <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>
              <div class="tabs__toggle">Level 2</div>
              <div class="tabs__toggle">Level 2</div>
            </div>
            <div class="tabs__tabs-group">
              <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
              <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
              <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
              <div class="tabs__tab"><h2>Level 2</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
              <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
              <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
              <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
              <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
              <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
            </div>
          </div>
        </body>
        <script type="text/javascript" src="js/commonUI.js"></script>
        <script>
          function init() {
            commonUI.initializeTabs({selector: '#liteVerticalTabsExample', vertical: true, responsive: true});
          }
          window.onload = init;
        </script>
        </html>`}>
      </iframe>
    </div>

    <pre><code className="language-javascript">{`commonUI.initializeTabs({vertical: true, responsive: true});`}</code></pre>

    <br/>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
      <pre className="hide-code"><code className="language-html">{`<div class="tabs tabs--lite tabs--vertical" id="liteVerticalTabsExample">
  <div class="tabs__toggle-group visuallyhidden--xs-only soft-half--top soft-half--bottom">
    <h5 class="tabs__toggle--title push-half">Category Title</h5>
    <div class="tabs__toggle tabs__toggle--active">Level 2</div>
    <div class="tabs__toggle">Level 2</div>
    <div class="tabs__toggle">Level 2</div>
    <h5 class="tabs__toggle--title push-half--sides push--top push-half--bottom">Category Title</h5>
    <div class="tabs__toggle">Level 2</div>
    <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>
    <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>
    <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>
    <div class="tabs__toggle">Level 2</div>
    <div class="tabs__toggle">Level 2</div>
  </div>
  <div class="tabs__tabs-group">
    <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
    <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
    <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
    <div class="tabs__tab"><h2>Level 2</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
    <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
    <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
    <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>
    <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>
    <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>
  </div>
</div>`}</code></pre>

    <br/>

    <hr/>
    </section>
  )
}
}

export default Tabs



// WEBPACK FOOTER //
// ./styleguide/components/sections/Tabs.js